import React, { createContext, useState, ReactNode } from "react";

interface VisibilityContextProps {
  isHidden: boolean;
  setIsHidden: React.Dispatch<React.SetStateAction<boolean>>;
}

interface VisibilityProviderProps {
  children: ReactNode;
}

export const VisibilityContext = createContext<VisibilityContextProps>({
  isHidden: false,
  setIsHidden: () => {}, // default no-op function
});

export const VisibilityProvider = ({ children }: VisibilityProviderProps) => {
  const [isHidden, setIsHidden] = useState(false);

  return (
    <VisibilityContext.Provider value={{ isHidden, setIsHidden }}>
      {children}
    </VisibilityContext.Provider>
  );
};
